jQuery( document ).ready(function($) {

  if($('.productchoice').length > 0) {

    let currentCheckbox
    let currentCheckboxId

    var popinShowed = 0;

    $(document).click(function(event) {
      console.log($(event.target));
      console.log('!');
      if (!$(event.target).is(".productchoice_popin_cadeau, .productchoice_button_cadeau, .nice_title, .label, .nice_paragraph, select") && popinShowed) {
          $(".productchoice_popin_cadeau").hide();
          popinShowed = 0;
      }
    });

    $('.productchoice_button_cadeau').click(function(){
      if(!popinShowed) {
        $('.productchoice_popin_cadeau').css('display', 'flex');
        $('#select_duree').val( $(this).data('duree') );
        
        $('.productchoice_checkbox').each((i, e) => {
          if($(e).prop("checked")) {
            //alert($(e).data('name'));
            console.log($(e).data('name').toLowerCase());
            $('#select_bateau').val( $(e).data('name').toLowerCase() );

          }
        });

        popinShowed = 1;
      }
    });
    

    $('.nice_button').click(function(){

      var duree = $('#select_duree').val();
      var bateau = $('#select_bateau').val();
      //alert(bateau + " " + duree);
      $.ajax({
        url : '/wp-content/themes/index/ajax-ajout-cadeau.php',
        method : 'POST',
        data : {
            lebateau : bateau,
            laduree : duree
        },
        success : function(code_html, statut){
          window.location.href = "/panier";
          //alert(code_html);
        }
      });
    });

    // Checkbox change //
    $('.productchoice_checkbox').on('change', (e) => {
      currentCheckbox = $(e.target).attr('data-id')
      currentCheckboxId = $(e.target).attr('id')
      testMulti()
      changeButton()
    })

    // No multi fomule slection //
    let testMulti = function() {
      $('.productchoice_checkbox').each((i, e) => {
        if($(e).attr('data-id') != currentCheckbox) {
          $(e).prop("checked", false)
        }
        if($(e).attr('id') != currentCheckboxId) {
          $(e).prop("checked", false)
        }
      })
    }

    // Change button color if checkob selected //
    let changeButton = function() {
      $('.productchoice_button_changeable').each((i, e) => {
        let elem = $(e)
        elem.removeClass('productchoice_button-valid')
        elem.addClass('productchoice_button-disabled')
        if(elem.attr('data-id') == currentCheckbox) {
          elem.addClass('productchoice_button-valid')
          elem.removeClass('productchoice_button-disabled')
        }
      })
    }

    $('.productchoice_button').on('click', (button) => {
      let addToCart = []
      button.preventDefault()
      $('.productchoice_checkbox').each((i, e) => {
        if($(e).prop("checked")) {
          addToCart.push(e.value)
        }
      })
      $.get("/?add-to-cart=" + addToCart[0], () => {
        if(addToCart[1]) {
          $.get("/?add-to-cart=" + addToCart[1], () => {
            window.location.href = '/panier'
          })
        } else {
          window.location.href = '/panier'
        }
      })
    })
  }
});